import { render, staticRenderFns } from "./CardsFilterForm.vue?vue&type=template&id=533adf24&"
import script from "./CardsFilterForm.vue?vue&type=script&lang=js&"
export * from "./CardsFilterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports